//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ReuseDatePickerDefaultCalculationId: FeatureFlag = {"Id":"ReuseDatePickerDefaultCalculationId","Label":"(KILL)[10.25]ReuseDatePickerDefaultCalculationId","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. When active, Date Period sub-control calculated default values reuse the parent's stable calculation id across re-initialization instead of minting a new one each time, so a fixated default value survives a reload instead of recalculating fresh.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
